import React, { useState } from "react";
import { /* Building2 */ } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import "./SignupPage.css";

export default function SignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.name && form.email && form.password && form.phone) {
      alert(`Account created for ${form.name}!`);
      navigate("/employee-dashboard"); // Redirect to dashboard after signup
    } else {
      alert("Please fill in all fields.");
    }
  };

  return (
    <div className="signup-root">
      <div className="signup-card">
        <h2 className="signup-title">Create Account</h2>

        <form onSubmit={handleSubmit} className="signup-form">
          <div className="signup-field">
            <label className="signup-label">Full Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="signup-input"
              required
            />
          </div>

          <div className="signup-field">
            <label className="signup-label">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="signup-input"
              required
            />
          </div>

          <div className="signup-field">
            <label className="signup-label">Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="signup-input"
              required
            />
          </div>

          <button type="submit" className="signup-button">Create Account</button>
        </form>

        <div className="signup-links">
          <Link to="/login" className="login-link">Already have an account? Login</Link>
        </div>
      </div>
    </div>
  );
}
